import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

type IconProps = {
  titleAccess?: string;
};

const FacebookIcon = ({ titleAccess }: IconProps) => (
  <SvgIcon titleAccess={titleAccess} viewBox="0 0 264 512">
    <path
      d="
      M76.7 512
      V283
      H0
      v-91
      h76.7
      v-71.7
      C76.7 42.4 124.3 0 193.8 0
      c33.3 0 61.9 2.5 70.2 3.6
      V85
      h-48.2
      c-37.8 0-45.1 18-45.1 44.3
      V192
      H256
      l-11.7 91
      h-73.6
      v229"
    />
  </SvgIcon>
);

export default FacebookIcon;
